import React, { useEffect, useState } from "react";
import { subscribe } from "../lib/serviceHealth";

// App-wide banner shown when the backend is degraded (Atlas no-primary /
// failover / capacity, or backend unreachable). It tells the user the platform
// is temporarily unavailable and retrying — it does NOT hide any controls and it
// does NOT fabricate data. Mounted once at the app root.
export default function ServiceStatusBanner() {
  const [degraded, setDegraded] = useState(false);

  useEffect(() => subscribe((d) => setDegraded(d)), []);

  if (!degraded) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#b45309",
        color: "#fff",
        padding: "8px 16px",
        fontSize: "14px",
        textAlign: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
      }}
    >
      Some services are temporarily unavailable. We’re retrying automatically —
      recent data may not load until the service recovers.
    </div>
  );
}

// Hook for components that render a "System Status" indicator: returns true when
// the platform is degraded so they can show "Degraded / Reconnecting" instead of
// a misleading "Online".
export function useServiceDegraded() {
  const [degraded, setDegraded] = useState(false);
  useEffect(() => subscribe((d) => setDegraded(d)), []);
  return degraded;
}
